import React from 'react';
import styled from 'styled-components';

import Dropdown from 'src/presentation/components/forms/Dropdown';
import { OpenerButton } from '@ad-scripts/presentation/components/common/dropdown_menu';

type ConditionOperatorProps = {
  attr: string;
  className?: string;
  disabled: boolean;
  index: number;
};

const Options = [
  { label: 'And', value: 'and' },
  { label: 'Or', value: 'or' },
];

const ConditionOperator = ({ attr, className, disabled, index }: ConditionOperatorProps) => {
  if (index === 0) {
    return <StyledIfLabel>If</StyledIfLabel>;
  }
  return (
    <StyledDropdown
      attr={attr}
      className={className}
      disabled={disabled}
      fitOpenerWidth={false}
      options={Options}
      placeholder={`And`}
    />
  );
};

export const StyledIfLabel = styled.div`
  align-items: flex-start;
  display: flex;
  font-weight: 700;
  justify-content: flex-start;
  padding-top: 12px;
`;

const StyledDropdown = styled(Dropdown)`
  overflow: hidden;
  ${OpenerButton} {
    background-color: transparent;
    border: 0;
    border-radius: 0;
    font-weight: 700;
    padding-left: 0;
    width: auto;
  }
`;

export default ConditionOperator;
